const config = {
  sensors: {
    sensorsServerUrl: 'https://sensorsapi.tianyancha.com/sa?project=default',
    sensorsDebug: true,
  },
  sentry: {
    dsn: 'https://13961c3112f44a76ae97d4be22344775@sentry-test.jindidata.com/6',
    tracesSampleRate: 1,
  },
  logger: {
    clsOrigin: 'https://cls-pre.tianyancha.com',
  },
  zipkin: {
    url: 'http://zipkin.test.tyc.io/',
    samplerRatio: 1,
  },
  xtransit: {
    server: 'ws://inner.xtransit.fronttyc.io:8643',
    appId: 20,
    appSecret: 'ede60d9c1bd271ef0044f2ca617c807d',
  },
  fetchConfig: {
    capiServer: 'https://capi.test63.tianyancha.com',
    napiServer: 'https://napi.test.tianyancha.com',
    gapiServer: 'https://api-gateway-test.tianyancha.com',
  },
  serverDomain: 'https://www.test63.tianyancha.com',
  qifuServerDomain: 'http://www.test.tianyanqifu.com',
  newsServerDomain: 'http://news.test63.tianyancha.com',
  discussServerDomain: 'http://discuss.test63.tianyancha.com',
  cookieServerSuffix: '.tianyancha.com',
  tokerServerDomain: 'http://sj.test.tianyancha.com',
  ownServerDomain: 'http://own.test63.tianyancha.com',

  ssrOriginCapi: 'http://cloud-gateway-test.services.huawei',
  ssrOriginNapi: 'http://inner.napi.test.fronttyc.io',
  ssrOriginNode: 'http://inner.napi.test.fronttyc.io', // TODO 下线，使用 napi
};

module.exports = config;
